import './index.less';
import classNames from 'classnames';

export const PriceNumber: React.FC<{
  price?: number;
}> = ({ price }) => {
  return (
    <span
      className={classNames('job-config-cal-cell-price', {
        large: price && price >= 10000,
      })}
    >
      ${price}
    </span>
  );
};
